import { render, staticRenderFns } from "./CookieBanner.vue?vue&type=template&id=58a47cf8"
import script from "./CookieBanner.vue?vue&type=script&lang=js"
export * from "./CookieBanner.vue?vue&type=script&lang=js"
import style0 from "./CookieBanner.vue?vue&type=style&index=0&id=58a47cf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports